import PropTypes from 'prop-types';
import React from 'react';
import { Col, Clearfix } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Header from '../Header/Header';

export class DedicatedWorkflowPanel extends React.Component {
  renderInstruction() {
    if (this.props.instruction) {
      return (
        <div>
          <p id="pageInstruction"><FormattedMessage { ...this.props.instruction } /></p>
          <div className="spacer small" />
        </div>
      );
    }

    return null;
  }

  renderHeader() {
    let header = null;
    if (this.props.instruction) {
      header = (<Header ariaDescribedby="pageInstruction"
        headerTitle={ <FormattedMessage { ...this.props.headerTitle } />}
        hasMessageDisplay
      />);
    } else {
      header = (<Header
        headerTitle={ <FormattedMessage { ...this.props.headerTitle } />}
        hasMessageDisplay
      />);
    }
    return header;
  }

  render() {
    return (
      <div className="row clearfix">
        <Col xs={12}>
          <div id="home-tabs-navs-contents">
            <div className="content-center-outer">
              <div className="content-center-mid">
                <div className="content-center-inner">
                  <Clearfix>
                    <Col md={8} sm={12} mdOffset={2}>
                      {this.renderHeader()}
                    </Col>
                  </Clearfix>
                  <Col md={8} sm={12} mdOffset={2}>
                    <div className="panel panel-default description-box notheme">
                      <Col className="panel-body">
                        <div className="content-area">
                          { this.renderInstruction() }
                          { this.props.children }
                        </div>
                      </Col>
                    </div>
                  </Col>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </div>

    );
  }
}

DedicatedWorkflowPanel.propTypes = {
  dispatch: PropTypes.func,
  headerTitle: PropTypes.object,
  instruction: PropTypes.object,
  children: PropTypes.array,
};